import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { completeTeamJoinInvite, getPublicTeamJoinInvite, requestPublicTeamJoinOtp, verifyPublicTeamJoinOtp } from '../../../services/matchService';

const normalizeJoinStatus = (status) => {
  const value = String(status || '').trim().toLowerCase();
  if (value === 'substitute') return 'substitute';
  if (value === 'unannounced') return 'unannounced';
  return 'playing';
};

export default function JoinTeamPage() {
  const { token } = useParams();
  const [invite, setInvite] = useState(null); const [form, setForm] = useState({ name: '', email: '', mobile: '', otp: '' }); const [msg, setMsg] = useState(''); const [loading, setLoading] = useState(false);
  const [requiresRegistration, setRequiresRegistration] = useState(false);
  useEffect(() => { getPublicTeamJoinInvite(token).then(setInvite).catch((e) => setMsg(e.message)); }, [token]);
  useEffect(() => {
    const authToken = localStorage.getItem('token');
    if (!authToken) return;
    completeTeamJoinInvite({ token: authToken, inviteToken: token })
      .then(() => setMsg('Successfully joined team.'))
      .catch(() => {});
  }, [token]);

  const handleRequestOtp = async () => {
    try {
      setLoading(true);
      await requestPublicTeamJoinOtp({ inviteToken: token, email: form.email, mobile: form.mobile });
      setMsg('OTP sent.');
    } catch (error) {
      setMsg(error.message || 'Unable to request OTP.');
    } finally {
      setLoading(false);
    }
  };

  const handleVerifyOtp = async () => {
    try {
      setLoading(true);
      const response = await verifyPublicTeamJoinOtp({ inviteToken: token, ...form });
      if (response?.requiresRegistration) {
        setRequiresRegistration(true);
        setMsg('Please login or create account to join this team.');
        return;
      }
      setMsg('Successfully joined team.');
    } catch (error) {
      setMsg(error.message || 'OTP verification failed.');
    } finally {
      setLoading(false);
    }
  };
  const resolvedJoinStatus = normalizeJoinStatus(invite?.joinStatus);
  const joinStatusLabel = resolvedJoinStatus === 'playing' ? 'Playing' : resolvedJoinStatus === 'substitute' ? 'Substitute' : 'Unannounced';

  return <div style={{ padding: 16 }}>
    <h2>Join Team</h2>
    {invite && <p>{invite?.tournament?.name} - {invite?.match?.team1} vs {invite?.match?.team2} ({invite?.teamKey})</p>}
    {invite && <p>You will join as: <strong>{joinStatusLabel}</strong></p>}
    <input placeholder='Name' value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} />
    <input placeholder='Email' value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} />
    <input placeholder='Mobile' value={form.mobile} onChange={(e) => setForm({ ...form, mobile: e.target.value })} />
    <button onClick={handleRequestOtp} disabled={loading}>Request OTP</button>
    <input placeholder='OTP' value={form.otp} onChange={(e) => setForm({ ...form, otp: e.target.value })} />
    <button onClick={handleVerifyOtp} disabled={loading}>Verify & Join</button>
    {requiresRegistration && (
      <button
        onClick={() => {
          const redirect = encodeURIComponent(`/join-team/${token}`);
          window.location.href = `/login?redirect=${redirect}`;
        }}
      >
        Login / Register
      </button>
    )}
    <p>{msg}</p>
  </div>;
}
